/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CouponDetailPage = lazyLoad(
  () => import('./index'),
  module => module.CouponDetailPage
);
